import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { useBranding } from "./BrandingContext";
import NavigationComponent from "./NavigationComponent";
import SkeletonPreview from "../../../components/SkeletonPreview";
import { RiCheckLine } from "react-icons/ri";
import BrandingHeader from "./components/brandingHeader";
const Container = styled.div.withConfig({ displayName: "Container", componentId: "-8q0xlc" }) `
  display: flex;
  flex-direction: column;
  
  &.mode-wizard {
    min-height: calc(100vh - 200px);
  }
`;
const UiContainer = styled.div.withConfig({ displayName: "UiContainer", componentId: "-ebe09t" }) `
  display: flex;
  flex-direction: column;
  margin-block: auto;
  gap: 10px;
  width: 100%;

  h2 {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 40px;
  }

  h3 {
    color: #3D3A3B;
    font-weight: 600;
    font-size: 14px;
    margin-bottom: 20px;
    text-align: center;
  }
`;
const SubmenuTypeUIContianer = styled.div.withConfig({ displayName: "SubmenuTypeUIContianer", componentId: "-vgxy7s" }) `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 25%;
`;
const OptionsContainer = styled.div.withConfig({ displayName: "OptionsContainer", componentId: "-12jc80e" }) `
  display: flex;
  gap: 60px;
`;
const OptionContainer = styled.div.withConfig({ displayName: "OptionContainer", componentId: "-1igoof0" }) `
  width: 280px;
`;
const SelectContainer = styled.div.withConfig({ displayName: "SelectContainer", componentId: "-h6w773" }) `
  position: relative;
  border: 2px solid transparent;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;

  &.selected {
    border-color: #512da8;
  }
`;
const SelectedCheck = styled.div.withConfig({ displayName: "SelectedCheck", componentId: "-gtcue6" }) `
  position: absolute;
  top: 0;
  right: 0;
  transform: translate(50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  background: #512da8;
  border: 3px solid white;
  border-radius: 50%;
  width: 30px;
  aspect-ratio: 1 / 1;
  color: white;
`;
const SubmenuType = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const { selectedTheme, setSelectedTheme } = useBranding();
    const [selectedType, setSelectedType] = React.useState(((_b = (_a = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _a === void 0 ? void 0 : _a.menuStyle) === null || _b === void 0 ? void 0 : _b.submenuType) || "compact");
    React.useEffect(() => {
        var _a;
        setSelectedTheme(Object.assign(Object.assign({}, selectedTheme), { themeSettings: Object.assign(Object.assign({}, selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings), { menuStyle: Object.assign(Object.assign({}, (_a = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _a === void 0 ? void 0 : _a.menuStyle), { submenuType: selectedType }) }) }));
    }, [selectedType]);
    return (_jsxs(Container, Object.assign({ className: props.wizardMode ? "mode-wizard" : "mode-edit" }, { children: [props.wizardMode ? (_jsx(BrandingHeader, { title: "Customize the menu style", summary: "Define button\u2019s text color and alignment on the MegaMenu.", advancedSettings: true })) : null, _jsx(UiContainer, { children: _jsxs(SubmenuTypeUIContianer, { children: [_jsx("h2", { children: "Submenu Type" }), _jsxs(OptionsContainer, { children: [_jsxs(OptionContainer, { children: [_jsx("h3", { children: "Classic submenu" }), _jsxs(SelectContainer, Object.assign({ onClick: () => setSelectedType("classic"), className: selectedType === "classic" ? "selected" : "" }, { children: [selectedType === "classic" ? (_jsx(SelectedCheck, { children: _jsx(RiCheckLine, {}) })) : null, _jsx(SkeletonPreview, { primaryColor: ((_d = (_c = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _c === void 0 ? void 0 : _c.color) === null || _d === void 0 ? void 0 : _d.primaryColor) || "#3D3A3B", style: ((_f = (_e = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _e === void 0 ? void 0 : _e.color) === null || _f === void 0 ? void 0 : _f.style) || "intense", menutype: "classic" })] }))] }), _jsxs(OptionContainer, { children: [_jsx("h3", { children: "Compact submenu" }), _jsxs(SelectContainer, Object.assign({ onClick: () => setSelectedType("compact"), className: selectedType === "compact" ? "selected" : "" }, { children: [selectedType === "compact" ? (_jsx(SelectedCheck, { children: _jsx(RiCheckLine, {}) })) : null, _jsx(SkeletonPreview, { primaryColor: ((_h = (_g = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _g === void 0 ? void 0 : _g.color) === null || _h === void 0 ? void 0 : _h.primaryColor) || "#3D3A3B", style: ((_k = (_j = selectedTheme === null || selectedTheme === void 0 ? void 0 : selectedTheme.themeSettings) === null || _j === void 0 ? void 0 : _j.color) === null || _k === void 0 ? void 0 : _k.style) || "intense", menutype: "compact" })] }))] })] })] }) }), props.wizardMode ? (_jsx(NavigationComponent, { currentStepName: "Submenu Type" })) : null] })));
};
export default SubmenuType;
